export const JsonHelper = {
  safeJsonParse<T>(str: string, fallbackValue: any = null): T | typeof fallbackValue {
    try {
      return JSON.parse(str);
    } catch {
      return fallbackValue;
    }
  }
};
